document.addEventListener('DOMContentLoaded', () => {

  const grids = document.querySelectorAll('.wg-categories__grid');

  if (!grids.length) return;

  grids.forEach((grid) => {

    let isDown = false;
    let startX = 0;
    let scrollLeft = 0;

    function isMobile() {
      return window.innerWidth <= 767;
    }

    /* =====================================
       DESKTOP DRAG SCROLL
    ===================================== */

    grid.addEventListener('mousedown', (e) => {

      if (isMobile()) return;

      isDown = true;

      grid.classList.add('dragging');

      startX = e.pageX - grid.offsetLeft;

      scrollLeft = grid.scrollLeft;

    });

    window.addEventListener('mouseup', () => {

      isDown = false;

      grid.classList.remove('dragging');

    });

    grid.addEventListener('mouseleave', () => {

      isDown = false;

      grid.classList.remove('dragging');

    });

    grid.addEventListener('mousemove', (e) => {

      if (!isDown) return;

      e.preventDefault();

      const x = e.pageX - grid.offsetLeft;

      const walk = (x - startX) * 1.4;

      grid.scrollLeft = scrollLeft - walk;

    });

    /* =====================================
       KEYBOARD SUPPORT
    ===================================== */

    grid.setAttribute('tabindex', '0');

    grid.addEventListener('keydown', (e) => {

      if (isMobile()) return;

      if (e.key === 'ArrowRight') {

        grid.scrollBy({
          left: 280,
          behavior: 'smooth'
        });

      }

      if (e.key === 'ArrowLeft') {

        grid.scrollBy({
          left: -280,
          behavior: 'smooth'
        });

      }

    });

  });

});